import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.iterator.js";
export var compare = function compare(a, b) {
  return a.values.net < b.values.net ? 1 : a.values.net > b.values.net ? -1 : 0;
};